<template>
  <div class="goods-and-image">
    <div v-if="$$FormData.title" class="title">{{ $$FormData.title }}</div>
    <div class="content">
      <div class="goods-list">
        <div v-for="item in $$FormData.goodsList" :key="item.goods_id" class="goods-item">
          <div v-if="item" class="inner-goods-item">
            <div class="goods-image">
              <img :src="item.goods_image" class="img-goods-image" />
            </div>
            <div class="goods-name">{{ item.goods_name }}</div>
            <div class="goods-price">
              <div v-if="false" class="goods-tag">售出概不退换</div>
              <div v-else></div>
              <div class="price">
                <div class="currency">￥</div>
                <div class="money">{{ item.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="image">
        <img v-if="picture && picture.image" :src="picture.image.src" class="img-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goodsAndImagePreview',
  data() {
    return {}
  },
  computed: {
    picture() {
      return this.$$FormData.picture
    }
  }
}
</script>

<style scoped lang="scss">
$red-color: #FF2121;
$box-shadow: 0 4px 10px 0 rgba(175, 175, 175, 0.3);
.goods-and-image {
  min-height: 150px;
  padding: 12px 10px;
  .title {
    font-size: 14px;
    padding-bottom: 12px;
  }
  .content {
    display: flex;
    gap: 6px;
  }
  .goods-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1;
    .goods-item {
      width: 109px;
      height: 142px;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: $box-shadow;
      .inner-goods-item {

      }
    }
    .goods-image {
      width: 109px;
      height: 94px;
      background-color: #fff;
      overflow: hidden;
      .img-goods-image {
        width: 100%;
        height: 100%;
      }
    }
    .goods-name {
      width: 100%;
      height: 25px;
      padding: 0 5px;
      margin-top: 3px;
      box-sizing: border-box;
      line-height: 13px;
      font-size: 10px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .goods-price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 6px;
    }
    .goods-tag {
      color: $red-color;
      font-size: 8px;
      border-radius: 2px;
      padding: 1px 1px;
      border: 1px solid $red-color;
    }
    .price {
      display: flex;
      align-items: flex-end;
      font-weight: bold;
      color: $red-color;
    }
    .currency {
      font-size: 9px;
    }
    .money {
      font-size: 12px;
    }
  }
  .image {
    width: 125px;
    height: 290px;
    flex-shrink: 0;
    background-color: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: $box-shadow;
    .img-image {
      width: 100%;
      height: 100%;
    }
  }
}
</style>